import store from '../../redux/store';
import { showMessageModal, showSignUp } from '../../redux/actions';
import { ckeckUserAccount } from '../../api/firebase/firebaseAuthentication';
import { EMAIL } from '../../redux/actions/types';
import { checkCustomerExistenceByEmailBackend } from '../../api';
import { EMAIL_ALREADY_USED_IN_FIREBASE_AUTH, EMAIL_EMPTY_DATA_ACCOUNT } from '../../constants';
import { logHighError } from '../../utils/logger';

export const isUserHasAccount = async (email: string) => {
  try {
    const result = await ckeckUserAccount(email);
    if (result.length === 0) {
      store.dispatch({ type: EMAIL, payload: email });
      store.dispatch(showSignUp(true));
    } else {
      const customerExistsInCompany = await checkCustomerExistenceByEmailBackend(email)
      if (!customerExistsInCompany) {
        store.dispatch(showMessageModal(EMAIL_ALREADY_USED_IN_FIREBASE_AUTH));
      } else {
        store.dispatch({ type: EMAIL, payload: email });
      }
    }
  } catch (error) {
    logHighError(`Error checking user account existence ${JSON.stringify(error)}`);
    store.dispatch(showMessageModal(EMAIL_EMPTY_DATA_ACCOUNT));
  }
};

export const validate = (email: string, formValues: any, isCheckPassword: boolean) => {
  const errors = {};
  if (!formValues.email && !email) {
    errors['email'] = 'Merci de fournir un mail';
  }

  if (isCheckPassword && !formValues.password) {
    errors['password'] = 'Merci de fournir un mot de passe';
  }
  return errors;
};
